"use strict";
if(!customElements.get('sticky-cart')) {
  class StickyCart extends HTMLElement {
    constructor() {
      super();
      var _this = this,
        secId = this.dataset.section,
        vr = this.querySelector('#stickyOptions');
  
      window.addEventListener("scroll",function(){
         var y = window.scrollY,
            btn = document.querySelector('.product-form__submit'),
            cartBtn = '300',
            mbQury = window.matchMedia('(max-width: 767px)');
          if(btn) {
            cartBtn = btn.offsetTop + 200;
            if(mbQury.matches === true) cartBtn = btn.offsetTop + window.innerHeight;
          }
          if(y > cartBtn){
           _this.classList.add('active');
          } else {
            _this.classList.remove('active');
          }
      });
      if(vr){
        vr.addEventListener('change', function(e){
            var opt = this.selectedOptions[0],
              vrcontainer = document.getElementById(`variant-selects-${secId}`).querySelectorAll('select, fieldset');
            vrcontainer.forEach((field, index) => {
              if(field.tagName === 'SELECT'){
                field.querySelectorAll("option").forEach((option) => {
                  if(option.value === opt.dataset[`option${index + 1}`]){
                    option.selected = true;
                  }
                });
              } else if(field.tagName === 'FIELDSET'){
                field.querySelectorAll("input").forEach((input) => {
                  input.removeAttribute("checked");
                  if(input.value === opt.dataset[`option${index + 1}`]){
                    input.click();
                  }
                });
              }
            });
        });
      }
  
      this.querySelectorAll('.linkQty').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
  
      const syncQty = document.querySelectorAll(".linkInput");
      syncQty.forEach((input) => {
          input.addEventListener("change", function(){
            const value = this.value;
            syncQty.forEach((otherInput) => {
              if (otherInput !== input) {
                otherInput.value = value;
              }
            });
          });
      });
    }
    onButtonClick(e){
      e.preventDefault();
      const qtyinput = document.querySelector('.mianQty'),
        previousValue = qtyinput.value;
      e.target.name === 'plus' ? qtyinput.stepUp() : qtyinput.stepDown();
      if(previousValue !== qtyinput.value) qtyinput.dispatchEvent(new Event("change"));
    }
  }
  customElements.define("sticky-cart", StickyCart);
}
if(!customElements.get('back-in-stock')){
  class BackInStock extends HTMLElement {
    constructor() {
      super();
      this.bisCookie = 'backinstock'+this.dataset.id;
      this.form = this.querySelector('form');
      this.variant = this.querySelector('.bisVariant');
  
      this.form.addEventListener("submit", this.BackinStockSubmit.bind(this));
  
      window.addEventListener('DOMContentLoaded',function(){
        const error = window.location.href.indexOf('form_type=contact') > -1;
        if(window.location.href.indexOf('contact_posted=true') > -1 || error){
            if(getCookie('contatForm') == 'backinstockform'){
                var bismodal = new tingle.modal({
                      cssClass: ['bismodal'],
                      onClose: function(){
                          setCookie('contatForm','',1);
                      }
                });
                bismodal.setContent(document.getElementById('backStockSuccess'));
                bismodal.open();
                
            }
        }
      });
    }
    BackinStockSubmit(event){
        event.preventDefault();
        var vrId = this.querySelector('.bisVariant').dataset.id,
          cvr = vrId;
        if(getCookie(this.bisCookie) != null){
            cvr = getCookie(this.bisCookie)+'_'+vrId;
        }
        setCookie(this.bisCookie,cvr,1);
        setCookie('contatForm','backinstockform',1);
    }
    checkBackinstock(vr){
      this.variant.value = vr.title;
      this.variant.setAttribute('data-id', vr.id);
      var formMsg = this.querySelector('.bisMsg');
      if(vr.available){
        this.classList.add('hide');
      } else {
        this.classList.remove('hide');
         if(getCookie(this.bisCookie) != null){
           this.form.classList.remove('hide');
           formMsg.classList.add('hide');
           var str = String(getCookie(this.bisCookie)).split("_");
           for(var i=0; i<str.length; i++){
             if(str[i] == vr.id){
               this.form.classList.add('hide');
               formMsg.classList.remove('hide');
             }
           }
         }
      }
     }
  }
  customElements.define("back-in-stock", BackInStock);
}

var tearmFields = document.querySelectorAll('.tearmCheck'),
  dyButs = document.querySelectorAll('.shopify-payment-button__button');

if(tearmFields.length){
  setTimeout(function(){
    dyButs.forEach((btn) => { btn.disabled = true; });
  },300);
  
  tearmFields.forEach((tearm) => {
    tearm.onchange = function(){
      var dyBut = this.closest('.product-form__buttons').querySelector('.shopify-payment-button__button');
      //dyBut.disabled = !this.checked;
    };
  });
  
}

(function(){
  document.querySelector('[data-pdp-show-ml]').onclick = function () {
    document.querySelector('[data-pdp-ct-d]').classList.toggle('show');
  };
})();


//=====Thumbnail (tee-thumbnail) và Color swatch (variant) sync với nhau======
/*===== FINAL FIX: ANCHOR BY DEFAULT COLOR + ACTIVE THUMB =====*/

let COLOR_TO_THUMB_MAP = {};
let IS_READY = false;

/*===== GET PRODUCT =====*/
function getProduct() {
  return window.productData || window.product || null;
}

/*===== GET COLOR INDEX =====*/
function getColorIndex(product) {
  if (!product || !product.options) return -1;

  return product.options.findIndex(opt =>
    String(opt).toLowerCase().includes('color') ||
    String(opt).toLowerCase().includes('màu')
  );
}

/*===== GET COLORS FROM VARIANTS =====*/
function getColorsFromVariants(product, COLOR_INDEX) {
  if (!product || !product.variants || COLOR_INDEX === -1) return [];

  const colors = [];

  product.variants.forEach(variant => {
    const color = variant.options && variant.options[COLOR_INDEX];
    if (color && !colors.includes(color)) {
      colors.push(color);
    }
  });

  return colors;
}

/*===== GET CURRENT SELECTED COLOR =====*/
function getCurrentSelectedColor(product, COLOR_INDEX) {
  if (!product || COLOR_INDEX === -1) return null;

  const optionName = product.options[COLOR_INDEX];
  if (!optionName) return null;

  const inputs = document.querySelectorAll(`[name="${optionName}"]`);

  for (const input of inputs) {
    if ((input.type === 'radio' || input.type === 'checkbox') && input.checked) {
      return input.value;
      }
  }

  const select = document.querySelector(`select[name="${optionName}"]`);
  if (select && select.value) {
    return select.value;
  }

  return null;
}

/*===== GET ACTIVE THUMB INDEX =====*/
function getActiveThumbIndex(thumbs) {
  if (!thumbs || !thumbs.length) return -1;

  let activeIndex = Array.from(thumbs).findIndex(thumb =>
    thumb.classList.contains('tee-thumbnail--active')
  );

  if (activeIndex === -1) {
    activeIndex = 0;
  }

  return activeIndex;
}

/*===== ROTATE ARRAY FROM ANCHOR =====*/
function rotateArrayFromValue(arr, anchorValue) {
  if (!arr.length) return [];
  if (!anchorValue) return arr.slice();

  const anchorIndex = arr.findIndex(item => item === anchorValue);

  if (anchorIndex === -1) {
    return arr.slice();
  }

  return [...arr.slice(anchorIndex), ...arr.slice(0, anchorIndex)];
}

/*===== SELECT COLOR =====*/
function selectColor(color) {
  const product = getProduct();
  if (!product) return;

  const COLOR_INDEX = getColorIndex(product);
  if (COLOR_INDEX === -1) return;

  const optionName = product.options[COLOR_INDEX];
  const inputs = document.querySelectorAll(`[name="${optionName}"]`);

  let changed = false;

  inputs.forEach(input => {
    if (input.value === color && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      changed = true;
    }
  });

  if (!changed) {
    const select = document.querySelector(`select[name="${optionName}"]`);
    if (select && select.value !== color) {
      select.value = color;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

/*===== BUILD MAP =====*/
function buildMap() {
  COLOR_TO_THUMB_MAP = {};

  const product = getProduct();
  if (!product) {
    console.warn('❌ No product data');
    return;
  }

  const COLOR_INDEX = getColorIndex(product);
  if (COLOR_INDEX === -1) {
    console.warn('❌ No color option found');
    return;
  }

  const baseColors = getColorsFromVariants(product, COLOR_INDEX);
  const thumbs = Array.from(document.querySelectorAll('.tee-thumbnail'));

  if (!baseColors.length || !thumbs.length) {
    console.warn('❌ Missing colors or thumbnails');
    console.groupEnd();
    return;
  }

  const currentSelectedColor = getCurrentSelectedColor(product, COLOR_INDEX);
  const activeThumbIndex = getActiveThumbIndex(thumbs);

  const orderedColors = rotateArrayFromValue(baseColors, currentSelectedColor);

  const len = Math.min(orderedColors.length, thumbs.length);

  for (let i = 0; i < len; i++) {
    const thumbIndex = (activeThumbIndex + i) % thumbs.length;
    const color = orderedColors[i];
    COLOR_TO_THUMB_MAP[color] = thumbIndex;
  }

  //console.table(COLOR_TO_THUMB_MAP);
  console.groupEnd();
}

/*===== GET COLOR BY THUMB INDEX =====*/
function getColorByThumbIndex(index) {
  return Object.keys(COLOR_TO_THUMB_MAP).find(color => COLOR_TO_THUMB_MAP[color] === index);
}

/*===== THUMB CLICK =====*/
function initThumbnailSync() {
  const thumbs = document.querySelectorAll('.tee-thumbnail');

  thumbs.forEach((thumb, index) => {
    if (thumb.dataset.colorSyncBound === 'true') return;

    thumb.dataset.colorSyncBound = 'true';

    thumb.addEventListener('click', () => {
      if (!IS_READY) return;

      //console.log('🖱 Click thumb:', index);

      const color = getColorByThumbIndex(index);

      //console.log('🎯 Found color:', color);

      if (!color) {
        console.warn('❌ No color mapped for thumb index:', index);
        return;
      }

      selectColor(color);
    });
  });
}

/*===== REBUILD WHEN COLOR CHANGES =====*/
function initColorWatcher() {
  const product = getProduct();
  if (!product) return;

  const COLOR_INDEX = getColorIndex(product);
  if (COLOR_INDEX === -1) return;

  const optionName = product.options[COLOR_INDEX];
  const inputs = document.querySelectorAll(`[name="${optionName}"]`);
  const select = document.querySelector(`select[name="${optionName}"]`);

  inputs.forEach(input => {
    if (input.dataset.colorWatcherBound === 'true') return;

    input.dataset.colorWatcherBound = 'true';
    input.addEventListener('change', () => {
      setTimeout(() => {
        buildMap();
      }, 50);
    });
  });

  if (select && select.dataset.colorWatcherBound !== 'true') {
    select.dataset.colorWatcherBound = 'true';
    select.addEventListener('change', () => {
      setTimeout(() => {
        buildMap();
      }, 50);
    });
  }
}

/*===== INIT =====*/
function initTeeinblueThumbColorSync() {
  const thumbs = document.querySelectorAll('.tee-thumbnail');

  if (!thumbs.length) return;

  console.log('🚀 INIT FINAL ANCHORED FIX');

  buildMap();
  initThumbnailSync();
  initColorWatcher();

  IS_READY = true;
}

/*===== OBSERVER =====*/
const observer = new MutationObserver((_, obs) => {
  const thumbs = document.querySelectorAll('.tee-thumbnail');

  if (thumbs.length > 0) {
    setTimeout(() => {
      initTeeinblueThumbColorSync();
    }, 100);

    obs.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});